import { ref } from 'vue'
import { defineStore } from 'pinia'
import Hotjar from '@hotjar/browser'
import { generateUUID } from '@/utils/crypto'

export const useHotjarStore = defineStore('hotjar', () => {
  const sessionId = ref('')
  const isInitialized = ref(false)
  const siteId = import.meta.env.VITE_HOTJAR_ID
  const hotjarVersion = 6

  function init() {
    if (!isInitialized.value && siteId) {
      sessionId.value = generateUUID()
      Hotjar.init(siteId, hotjarVersion)
      Hotjar.identify(null, { session_id: sessionId.value })
      isInitialized.value = true
    }
  }

  return { init, sessionId, isInitialized }
})
